import { Card, Divider, Flex } from 'antd';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

// components
import StatusComponent from 'components/status/status';
import NumberElement from 'components/number/number';

interface MajorShareholderItemProps {
	name: string;
	common: number;
	equity: number;
}

const MajorShareholderItem: FunctionComponent<MajorShareholderItemProps> = ({ common, equity, name }) => {
	const { t } = useTranslation();

	return (
		<Card className="h-100">
			<Flex vertical justify="space-between" style={{ minHeight: 150, height: '100%', justifyContent: 'space-between' }}>
				<h5>{name}</h5>

				<div className="mt-2">
					<Flex gap={10} wrap>
						<StatusComponent
							color="white"
							bordered
							text={
								<span className="mb-0 d-flex align-items-center">
									{t('COMPANY_INFORMATION.COUNT')}:
									<span className="fw-medium">
										<NumberElement value={common} style={{ marginInlineStart: 5 }} />
									</span>
								</span>
							}
						/>
					</Flex>

					<Divider style={{ marginBlock: '20px 10px' }} />

					<Flex justify="space-between" align="center">
						<p className="text-light fw-medium mb-0">{t('COMMON.EQUITY')}</p>

						<h6 className="text-success mb-0 fw-bold">{equity.toFixed(2)}%</h6>
					</Flex>
				</div>
			</Flex>
		</Card>
	);
};

export default MajorShareholderItem;
